// client/src/utils/date.js
// Date formatting helpers (dd/mm/yyyy)
function formatParts(day, month, year) {
    if (!day || !month || !year) return '';
    const paddedDay = String(day).padStart(2, '0');
    const paddedMonth = String(month).padStart(2, '0');
    const normalizedYear = String(year).length === 2 ? `20${year}` : String(year);
    return `${paddedDay}/${paddedMonth}/${normalizedYear}`;
}

export function formatDate(value) {
    if (!value) return '';
    if (typeof value === 'string') {
        const trimmed = value.trim();
        const isoMatch = trimmed.match(/^(\d{4})[/-](\d{2})[/-](\d{2})$/);
        if (isoMatch) {
            return formatParts(isoMatch[3], isoMatch[2], isoMatch[1]);
        }
        const dmMatch = trimmed.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
        if (dmMatch) {
            return formatParts(dmMatch[1], dmMatch[2], dmMatch[3]);
        }
    }
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return formatParts(date.getDate(), date.getMonth() + 1, date.getFullYear());
}

export function normalizeDateInput(rawValue) {
    if (rawValue === null || rawValue === undefined) return '';
    const cleaned = String(rawValue).trim().replace(/-/g, '/').replace(/[^\d/]/g, '');
    if (!cleaned) return '';
    const isoMatch = cleaned.match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
    if (isoMatch) {
        return formatParts(isoMatch[3], isoMatch[2], isoMatch[1]);
    }
    const dmMatch = cleaned.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
    if (dmMatch) {
        return formatParts(dmMatch[1], dmMatch[2], dmMatch[3]);
    }
    const digitsOnly = cleaned.replace(/\//g, '');
    if (digitsOnly.length === 8) {
        return formatParts(digitsOnly.slice(0, 2), digitsOnly.slice(2, 4), digitsOnly.slice(4));
    }
    return cleaned;
}
